import { render, staticRenderFns } from "./AstaDrawer.vue?vue&type=template&id=335bebc0&scoped=true&"
import script from "./AstaDrawer.vue?vue&type=script&lang=js&"
export * from "./AstaDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AstaDrawer.vue?vue&type=style&index=0&id=335bebc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335bebc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335bebc0')) {
      api.createRecord('335bebc0', component.options)
    } else {
      api.reload('335bebc0', component.options)
    }
    module.hot.accept("./AstaDrawer.vue?vue&type=template&id=335bebc0&scoped=true&", function () {
      api.rerender('335bebc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaDrawer.vue"
export default component.exports